export const noRowsTemplate = {
  template: `
      <div>
          <svg
      id="gift_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 24 24"
    >
      <g id="Group_3" data-name="Group 3">
        <path
          id="Path_1404"
          data-name="Path 1404"
          d="M20,8H4A1,1,0,0,0,3,9v2a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V9A1,1,0,0,0,20,8Z"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
          fill-rule="evenodd"
        />
        <path
          id="Path_1405"
          data-name="Path 1405"
          d="M12,21V8"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1406"
          data-name="Path 1406"
          d="M15.7,6.612A5.294,5.294,0,0,1,12.1,8"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1407"
          data-name="Path 1407"
          d="M12.1,8s-.494-3.116.721-4.38"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1408"
          data-name="Path 1408"
          d="M15.7,6.612a2.177,2.177,0,0,0,0-2.992,1.978,1.978,0,0,0-2.875,0"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1409"
          data-name="Path 1409"
          d="M8.3,6.612A5.294,5.294,0,0,0,11.9,8"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1410"
          data-name="Path 1410"
          d="M11.9,8s.494-3.116-.721-4.38"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1411"
          data-name="Path 1411"
          d="M8.3,6.612a2.177,2.177,0,0,1,0-2.992,1.978,1.978,0,0,1,2.875,0"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
        />
        <path
          id="Path_1412"
          data-name="Path 1412"
          d="M19,12v8a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V12"
          fill="none"
          stroke="#bbb"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.7"
          fill-rule="evenodd"
        />
      </g>
      <path id="Path_1413" data-name="Path 1413" d="M0,0H24V24H0Z" fill="none" />
    </svg>
    <p class="font-Regular-14" style="color:#BBBBBB;">هنوز پاداشی دریافت نکرده‌اید</p>
    </div>`
};
